export const ActionTypesConstants = {
    ADD: 'ADD',
    EDIT: 'EDIT'
};